// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader[data-v-01a8b75c]{position:fixed}`, "",{"version":3,"sources":["webpack://./src/js/vue/components/Booking/Step1/DateScreenStep.vue"],"names":[],"mappings":"AACA,yBACE,cAAA","sourcesContent":["\r\n.loader {\r\n  position: fixed;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
